const RidesData = [
    {
        "id": 193,
        "origin_station_code": 15,
        "station_path": [
            22,
            32,
            42,
            52,
            61,
            75,
            83
        ],
        "destination_station_code": 91,
        "date": "12/26/2021 07:36 PM",
        "map_url": "https://picsum.photos/200",
        "state": "Kerala",
        "city": "Attingal"
    },
    {
        "id": 927,
        "origin_station_code": 18,
        "station_path": [
            48,
            59,
            66,
            77,
            85
        ],
        "destination_station_code": 95,
        "date": "12/26/2021 10:12 AM",
        "map_url": "https://picsum.photos/200",
        "state": "Assam",
        "city": "Rangia"
    },
    {
        "id": 699,
        "origin_station_code": 5,
        "station_path": [
            61,
            78,
            81
        ],
        "destination_station_code": 91,
        "date": "02/02/2022 05:18 PM",
        "map_url": "https://picsum.photos/200",
        "state": "Dadra and Nagar Haveli",
        "city": "Silvassa"
    },
    {
        "id": 246,
        "origin_station_code": 11,
        "station_path": [
            26,
            30,
            46,
            53,
            60,
            77,
            88
        ],
        "destination_station_code": 91,
        "date": "02/28/2022 02:23 PM",
        "map_url": "https://picsum.photos/200",
        "state": "Jammu and Kashmir",
        "city": "KathUrban Agglomeration"
    },
    {
        "id": 336,
        "origin_station_code": 3,
        "station_path": [
            49,
            52,
            64,
            71,
            83
        ],
        "destination_station_code": 94,
        "date": "02/02/2022 11:51 AM",
        "map_url": "https://picsum.photos/200",
        "state": "Goa",
        "city": "Margao"
    },
    {
        "id": 369,
        "origin_station_code": 13,
        "station_path": [
            51,
            65,
            73,
            84
        ],
        "destination_station_code": 90,
        "date": "01/25/2022 02:29 AM",
        "map_url": "https://picsum.photos/200",
        "state": "Telangana",
        "city": "Mahbubnagar"
    },
    {
        "id": 235,
        "origin_station_code": 17,
        "station_path": [
            24,
            36,
            44,
            51,
            61,
            70,
            87
        ],
        "destination_station_code": 91,
        "date": "02/10/2022 10:47 PM",
        "map_url": "https://picsum.photos/200",
        "state": "Manipur",
        "city": "Thoubal"
    },
    {
        "id": 990,
        "origin_station_code": 3,
        "station_path": [
            68,
            71,
            84
        ],
        "destination_station_code": 97,
        "date": "12/31/2021 10:32 AM",
        "map_url": "https://picsum.photos/200",
        "state": "Tamil Nadu",
        "city": "Valparai"
    },
    {
        "id": 662,
        "origin_station_code": 5,
        "station_path": [
            30,
            48,
            51,
            68,
            73,
            86
        ],
        "destination_station_code": 92,
        "date": "01/07/2022 11:41 AM",
        "map_url": "https://picsum.photos/200",
        "state": "Gujarat",
        "city": "Pardi"
    },
    {
        "id": 925,
        "origin_station_code": 13,
        "station_path": [
            26,
            37,
            48,
            58,
            68,
            77,
            88
        ],
        "destination_station_code": 94,
        "date": "02/23/2022 07:17 PM",
        "map_url": "https://picsum.photos/200",
        "state": "Rajasthan",
        "city": "Prantij"
    },
    {
        "id": 481,
        "origin_station_code": 5,
        "station_path": [
            68,
            74,
            87
        ],
        "destination_station_code": 98,
        "date": "01/20/2022 04:14 PM",
        "map_url": "https://picsum.photos/200",
        "state": "Dadra and Nagar Haveli",
        "city": "Silvassa"
    },
    {
        "id": 435,
        "origin_station_code": 17,
        "station_path": [
            59,
            65,
            79,
            84
        ],
        "destination_station_code": 94,
        "date": "02/28/2022 04:57 AM",
        "map_url": "https://picsum.photos/200",
        "state": "Punjab",
        "city": "Dhuri"
    },
    {
        "id": 892,
        "origin_station_code": 12,
        "station_path": [
            58,
            68,
            74,
            86
        ],
        "destination_station_code": 90,
        "date": "01/12/2022 12:41 PM",
        "map_url": "https://picsum.photos/200",
        "state": "Madhya Pradesh",
        "city": "Sendhwa"
    },
    {
        "id": 826,
        "origin_station_code": 9,
        "station_path": [
            26,
            39,
            44,
            54,
            69,
            70,
            86
        ],
        "destination_station_code": 90,
        "date": "01/21/2022 04:21 AM",
        "map_url": "https://picsum.photos/200",
        "state": "West Bengal",
        "city": "Baharampur"
    },
    {
        "id": 372,
        "origin_station_code": 9,
        "station_path": [
            44,
            50,
            69,
            78,
            80
        ],
        "destination_station_code": 90,
        "date": "02/20/2022 01:03 PM",
        "map_url": "https://picsum.photos/200",
        "state": "Odisha",
        "city": "Sunabeda"
    },
    {
        "id": 338,
        "origin_station_code": 1,
        "station_path": [
            58,
            67,
            71,
            85
        ],
        "destination_station_code": 90,
        "date": "12/23/2021 05:04 AM",
        "map_url": "https://picsum.photos/200",
        "state": "Odisha",
        "city": "Nabarangapur"
    },
    {
        "id": 712,
        "origin_station_code": 8,
        "station_path": [
            65,
            77,
            81
        ],
        "destination_station_code": 92,
        "date": "01/13/2022 07:00 AM",
        "map_url": "https://picsum.photos/200",
        "state": "Punjab",
        "city": "Raikot"
    },
    {
        "id": 467,
        "origin_station_code": 19,
        "station_path": [
            36,
            40,
            54,
            68,
            73,
            85
        ],
        "destination_station_code": 98,
        "date": "01/09/2022 07:14 PM",
        "map_url": "https://picsum.photos/200",
        "state": "Jammu and Kashmir",
        "city": "Rajauri"
    },
    {
        "id": 606,
        "origin_station_code": 16,
        "station_path": [
            35,
            45,
            59,
            67,
            76,
            80
        ],
        "destination_station_code": 94,
        "date": "03/02/2022 07:29 AM",
        "map_url": "https://picsum.photos/200",
        "state": "Uttarakhand",
        "city": "Nagla"
    },
    {
        "id": 757,
        "origin_station_code": 16,
        "station_path": [
            27,
            39,
            44,
            57,
            61,
            72,
            80
        ],
        "destination_station_code": 94,
        "date": "02/02/2022 03:31 PM",
        "map_url": "https://picsum.photos/200",
        "state": "Delhi",
        "city": "Delhi"
    },
    {
        "id": 554,
        "origin_station_code": 8,
        "station_path": [
            44,
            55,
            67,
            78,
            84
        ],
        "destination_station_code": 91,
        "date": "02/22/2022 01:42 AM",
        "map_url": "https://picsum.photos/200",
        "state": "Kerala",
        "city": "Muvattupuzha"
    },
    {
        "id": 737,
        "origin_station_code": 18,
        "station_path": [
            42,
            53,
            62,
            71,
            85
        ],
        "destination_station_code": 93,
        "date": "01/22/2022 01:50 PM",
        "map_url": "https://picsum.photos/200",
        "state": "Rajasthan",
        "city": "Nimbahera"
    },
    {
        "id": 942,
        "origin_station_code": 6,
        "station_path": [
            48,
            59,
            66,
            72,
            82
        ],
        "destination_station_code": 92,
        "date": "02/12/2022 05:26 AM",
        "map_url": "https://picsum.photos/200",
        "state": "Dadra and Nagar Haveli",
        "city": "Silvassa"
    },
    {
        "id": 778,
        "origin_station_code": 5,
        "station_path": [
            55,
            65,
            71,
            88
        ],
        "destination_station_code": 98,
        "date": "12/28/2021 06:25 PM",
        "map_url": "https://picsum.photos/200",
        "state": "Manipur",
        "city": "Lilong"
    },
    {
        "id": 988,
        "origin_station_code": 1,
        "station_path": [
            20,
            35,
            49,
            50,
            61,
            71,
            85
        ],
        "destination_station_code": 97,
        "date": "02/15/2022 12:01 AM",
        "map_url": "https://picsum.photos/200",
        "state": "Meghalaya",
        "city": "Shillong"
    },
    {
        "id": 687,
        "origin_station_code": 2,
        "station_path": [
            49,
            56,
            65,
            77,
            80
        ],
        "destination_station_code": 98,
        "date": "02/20/2022 02:51 AM",
        "map_url": "https://picsum.photos/200",
        "state": "Odisha",
        "city": "Nabarangapur"
    },
    {
        "id": 833,
        "origin_station_code": 9,
        "station_path": [
            47,
            52,
            67,
            72,
            87
        ],
        "destination_station_code": 91,
        "date": "12/18/2021 02:37 AM",
        "map_url": "https://picsum.photos/200",
        "state": "Nagaland",
        "city": "Tuensang"
    },
    {
        "id": 614,
        "origin_station_code": 14,
        "station_path": [
            62,
            78,
            81
        ],
        "destination_station_code": 91,
        "date": "02/26/2022 05:55 AM",
        "map_url": "https://picsum.photos/200",
        "state": "Assam",
        "city": "North Lakhimpur"
    },
    {
        "id": 484,
        "origin_station_code": 10,
        "station_path": [
            35,
            40,
            58,
            63,
            72,
            84
        ],
        "destination_station_code": 96,
        "date": "12/24/2021 04:19 PM",
        "map_url": "https://picsum.photos/200",
        "state": "Rajasthan",
        "city": "Shahpura"
    },
    {
        "id": 590,
        "origin_station_code": 18,
        "station_path": [
            31,
            46,
            55,
            64,
            77,
            86
        ],
        "destination_station_code": 93,
        "date": "12/24/2021 04:27 PM",
        "map_url": "https://picsum.photos/200",
        "state": "Meghalaya",
        "city": "Shillong"
    },
    {
        "id": 856,
        "origin_station_code": 6,
        "station_path": [
            44,
            50,
            61,
            74,
            80
        ],
        "destination_station_code": 91,
        "date": "01/26/2022 09:08 PM",
        "map_url": "https://picsum.photos/200",
        "state": "Tripura",
        "city": "Khowai"
    },
    {
        "id": 128,
        "origin_station_code": 2,
        "station_path": [
            56,
            64,
            78,
            80
        ],
        "destination_station_code": 95,
        "date": "12/22/2021 03:07 PM",
        "map_url": "https://picsum.photos/200",
        "state": "Jharkhand",
        "city": "Jhumri Tilaiya"
    },
    {
        "id": 164,
        "origin_station_code": 4,
        "station_path": [
            23,
            38,
            49,
            59,
            66,
            78,
            81
        ],
        "destination_station_code": 90,
        "date": "02/13/2022 09:07 AM",
        "map_url": "https://picsum.photos/200",
        "state": "Haryana",
        "city": "Ratia"
    },
    {
        "id": 970,
        "origin_station_code": 5,
        "station_path": [
            60,
            78,
            81
        ],
        "destination_station_code": 94,
        "date": "02/12/2022 02:20 AM",
        "map_url": "https://picsum.photos/200",
        "state": "Andaman and Nicobar Islands",
        "city": "Port Blair"
    },
    {
        "id": 159,
        "origin_station_code": 19,
        "station_path": [
            32,
            47,
            50,
            67,
            73,
            83
        ],
        "destination_station_code": 98,
        "date": "02/05/2022 10:36 AM",
        "map_url": "https://picsum.photos/200",
        "state": "West Bengal",
        "city": "Kalimpong"
    },
    {
        "id": 658,
        "origin_station_code": 19,
        "station_path": [
            34,
            45,
            55,
            60,
            73,
            85
        ],
        "destination_station_code": 90,
        "date": "01/11/2022 09:08 AM",
        "map_url": "https://picsum.photos/200",
        "state": "Dadra and Nagar Haveli",
        "city": "Silvassa"
    },
    {
        "id": 609,
        "origin_station_code": 6,
        "station_path": [
            44,
            55,
            63,
            71,
            83
        ],
        "destination_station_code": 99,
        "date": "01/19/2022 03:01 PM",
        "map_url": "https://picsum.photos/200",
        "state": "Arunachal Pradesh",
        "city": "Pasighat"
    },
    {
        "id": 465,
        "origin_station_code": 19,
        "station_path": [
            48,
            58,
            65,
            72,
            84
        ],
        "destination_station_code": 90,
        "date": "02/14/2022 11:15 AM",
        "map_url": "https://picsum.photos/200",
        "state": "Karnataka",
        "city": "Belagavi"
    },
    {
        "id": 344,
        "origin_station_code": 6,
        "station_path": [
            55,
            62,
            78,
            88
        ],
        "destination_station_code": 97,
        "date": "02/28/2022 09:39 PM",
        "map_url": "https://picsum.photos/200",
        "state": "Chandigarh",
        "city": "Chandigarh"
    },
    {
        "id": 489,
        "origin_station_code": 18,
        "station_path": [
            43,
            53,
            64,
            78,
            85
        ],
        "destination_station_code": 93,
        "date": "02/22/2022 04:36 AM",
        "map_url": "https://picsum.photos/200",
        "state": "Andaman and Nicobar Islands",
        "city": "Port Blair"
    },
    {
        "id": 545,
        "origin_station_code": 9,
        "station_path": [
            44,
            53,
            65,
            72,
            80
        ],
        "destination_station_code": 95,
        "date": "01/05/2022 08:54 AM",
        "map_url": "https://picsum.photos/200",
        "state": "Gujarat",
        "city": "Mahesana"
    },
    {
        "id": 227,
        "origin_station_code": 6,
        "station_path": [
            59,
            68,
            79,
            87
        ],
        "destination_station_code": 98,
        "date": "02/25/2022 12:45 AM",
        "map_url": "https://picsum.photos/200",
        "state": "Gujarat",
        "city": "Khambhat"
    },
    {
        "id": 291,
        "origin_station_code": 10,
        "station_path": [
            46,
            53,
            61,
            77,
            84
        ],
        "destination_station_code": 91,
        "date": "01/12/2022 01:04 AM",
        "map_url": "https://picsum.photos/200",
        "state": "Dadra and Nagar Haveli",
        "city": "Silvassa"
    },
    {
        "id": 388,
        "origin_station_code": 9,
        "station_path": [
            56,
            69,
            79,
            82
        ],
        "destination_station_code": 95,
        "date": "02/15/2022 10:25 AM",
        "map_url": "https://picsum.photos/200",
        "state": "Odisha",
        "city": "Nabarangapur"
    },
    {
        "id": 790,
        "origin_station_code": 7,
        "station_path": [
            41,
            54,
            63,
            72,
            87
        ],
        "destination_station_code": 95,
        "date": "12/19/2021 03:19 AM",
        "map_url": "https://picsum.photos/200",
        "state": "Telangana",
        "city": "Khammam"
    },
    {
        "id": 917,
        "origin_station_code": 15,
        "station_path": [
            56,
            68,
            73,
            86
        ],
        "destination_station_code": 96,
        "date": "12/23/2021 08:22 PM",
        "map_url": "https://picsum.photos/200",
        "state": "Tamil Nadu",
        "city": "Periyasemur"
    },
    {
        "id": 898,
        "origin_station_code": 11,
        "station_path": [
            32,
            49,
            53,
            60,
            74,
            83
        ],
        "destination_station_code": 96,
        "date": "01/14/2022 06:55 PM",
        "map_url": "https://picsum.photos/200",
        "state": "West Bengal",
        "city": "Taki"
    },
    {
        "id": 505,
        "origin_station_code": 19,
        "station_path": [
            43,
            58,
            61,
            74,
            84
        ],
        "destination_station_code": 95,
        "date": "02/26/2022 01:11 AM",
        "map_url": "https://picsum.photos/200",
        "state": "Madhya Pradesh",
        "city": "Lahar"
    },
    {
        "id": 563,
        "origin_station_code": 19,
        "station_path": [
            28,
            38,
            41,
            50,
            62,
            74,
            87
        ],
        "destination_station_code": 90,
        "date": "12/19/2021 07:27 PM",
        "map_url": "https://picsum.photos/200",
        "state": "Karnataka",
        "city": "Ranebennuru"
    }
]

export default RidesData;